import { NavLink, useLocation } from "react-router-dom";
import { LayoutDashboard, Receipt, FileCheck2, Wallet, Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

const ITEMS = [
    { to: "/", label: "Home", icon: LayoutDashboard, exact: true },
    { to: "/sales/invoices", label: "Sales", icon: Receipt },
    { to: "/purchases/bills", label: "Bills", icon: FileCheck2 },
    { to: "/banking/accounts", label: "Banking", icon: Wallet },
    { to: "/copilot", label: "Copilot", icon: Sparkles },
];

export default function MobileBottomNav() {
    const loc = useLocation();
    return (
        <nav
            data-testid="mobile-bottom-nav"
            className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-card/95 backdrop-blur-md border-t border-border grid grid-cols-5 h-[60px]"
        >
            {ITEMS.map((it) => {
                const Icon = it.icon;
                const active = it.exact ? loc.pathname === it.to : loc.pathname.startsWith(it.to);
                return (
                    <NavLink
                        key={it.to}
                        to={it.to}
                        data-testid={`mobile-nav-${it.label.toLowerCase()}`}
                        className={cn(
                            "flex flex-col items-center justify-center gap-1 text-[10.5px] font-medium transition-colors",
                            active ? "text-foreground" : "text-muted-foreground"
                        )}
                    >
                        <div className={cn("relative", active && "after:content-[''] after:absolute after:-top-3.5 after:left-1/2 after:-translate-x-1/2 after:w-7 after:h-[2px] after:bg-gold after:rounded-full")}>
                            <Icon className="w-[20px] h-[20px]" strokeWidth={1.6} />
                        </div>
                        <span>{it.label}</span>
                    </NavLink>
                );
            })}
        </nav>
    );
}
